<template>
  <div>
    <memlist-modal size="xl" ref="chat-modal">
      <template v-slot:header>
        <div class="header-slot" v-if="task"><b>{{ task.name }}</b></div>
      </template>
      
      <div class="change-history" v-if="histories && histories.length > 0">
        <div v-for="(change, index) in histories" :key="index">
          <div
            v-if="currentUser && change.author"
            class="change-item"
            :class="{
              'my-change': change.author.user_id === currentUser.user_id,
              'other-change': change.author.user_id !== currentUser.user_id,
              'unread': !change.read_at
            }"
          >
            <div class="change-content">
              <div class="user-info">
                <span class="user-name">{{ change.author.firstname }} {{ change.author.lastname }}</span>
                <span class="user-email">{{ change.author.email }}</span>
              </div>

              <div class="change-details">
                <p class="timestamp">{{ formatDate(change.created_at) }}</p>

                <div v-if="change.type === 'FILE_CREATED'" class="file-change">
                  <p v-if="!change.file">
                    Fel: Fil saknas
                  </p>
                  <p v-else>
                    Fil:
                    <a class="download-link" @click="download_file_clicked(change.file_id)" target="_blank">{{ change.file.name }}</a>
                  </p>
                </div>

                <div v-else-if="change.type === 'COMMENT_CREATED'" class="comment-change">
                  <p>
                    {{ change.message }}
                  </p>
                </div>
              </div>
            </div>
          </div>


        </div>

        <m-row>
          <m-col lg="6">
            <memlist-image-dropzone-upload
              class="mt-2"
              v-model="dropzone_image"
              @uploaded="on_file_uploaded"
            />
          </m-col>
          <m-col lg="6">
            <m-row>
              <m-col lg="8">
                <memlist-textarea
                  id="text_chatmessage"
                  name="text_chatmessage"
                  layout="vertical"
                  v-model="input_text"
                  size="lg"
                  rows="4"
                />
              </m-col>
              <m-col lg="4">
                <memlist-button
                  class="mb-8 mt-2"
                  size="lg"
                  @click="send_message_clicked"
                >
                  Skicka
                </memlist-button>
              </m-col>
            </m-row>
          </m-col>
        </m-row>
      </div>
      <div v-else>
        <memlist-inline-alert variant="info">
          Ingen aktivitet
        </memlist-inline-alert>
      </div>

    </memlist-modal>
  </div>
  
  
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';

export default {
  name: 'TaskChatAndFileModal',
  emits: ['created'],
  props: {
    histories: {
      type: Array,
      required: true,
    },
    task: {
      type: Object,
      required: true
    }
  },
  watch: {
    histories: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.read_history();
      },
      immediate: true
    },
    currentCompanyId() {
      
    }
  },

  data() {
    return {
      dropzone_image: null,
      input_text: null
    }
  },
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'currentUser']),
  },

  methods: {
    async download_file_clicked(file_id) {

      try {
        const res = await axios.get(`/file/${file_id}`);

        if (res.status === 200) {
          downloadWithAxios(get_base_url() + `/dlfile/${res.data.linkstr}`, res.data.name);
          return;
        }
      }
      catch (err) {
        console.error('download_invoice', err);
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.FILES.UNABLE_DOWNLOAD'));
      
    },


    show() {
      this.$refs['chat-modal'].show();
    },
    hide() {
      this.$refs['chat-modal'].hide();
    },
    async read_history() {
      try {
        if (!this.histories || this.histories.length === 0) {
          return;
        }

        console.log('this.histories',this.histories);

        const res = await axios.post(`/todo/read/history`, { ids: this.histories.map(i => i.id) });

        if (res.status === 200) {
          console.log('read history OK');
        }
        else {
          console.error('unable to read history');
        }
      }
      catch (err) {
        console.error('read_history error', err);
      }
    },
    async send_message_clicked() {
      if (!this.input_text || this.input_text.length === 0) {
        return;
      }

      try {
        const res = await axios.post(`/todo_task/comment/${this.task.todo_task_id}`, {
          comment: this.input_text,
          is_top: true,
        });

        if (res.status === 201) {
          this.$emit('created', res.data);
          this.input_text = null;
        }
      }
      catch (err) {
        console.error('send_message_clicked error', err);
      }
    },
    on_file_uploaded(file) {

    },
    formatDate(datetime) {
      return new Date(datetime).toLocaleString(); // Customize formatting as needed
    },
  },
};
</script>

<style scoped>
.download-link:hover {
  cursor: pointer;
}

.header-slot {
  padding: 12px;
  border-radius: 8px;
  background-color: #f5f5f5;
  min-width: 512px;
  margin-top: 8px;
}

.change-history {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Message wrapper */
.change-item {
  display: flex;
  width: 100%;
}

/* My messages */
.my-change {
  justify-content: flex-end;
}

/* Others' messages */
.other-change {
  justify-content: flex-start;
}

/* Shared message content styling */
.change-content {
  background-color: #cee6ff; /* Default to blue for my messages */
  color: black;
  border-radius: 8px;
  padding: 10px;
  max-width: 80%;
  word-wrap: break-word;
  min-width: 600px;
}

/* Override background for others */
.other-change .change-content {
  background-color: #f0f0f0;
  color: black;
}

/* Unread icon */
.unread .new-indicator {
  margin-left: 5px;
  color: #007bff;
  font-size: 1em;
}

/* Inside content */
.comment-change {
  font-style: italic;
  color: inherit;
  margin-top: 5px;
  font-size: 1em;
}

.user-info {
  font-size: 0.85em;
  color: #555;
}

.timestamp {
  font-size: 0.75em;
  color: #aaa;
  margin-bottom: 10px;
}

.file-change {
  margin-top: 5px;
  font-size: 1em;
}

.file-change a {
  color: #007bff;
  text-decoration: none;
}

.file-change a:hover {
  text-decoration: underline;
}
</style>
